/**
 * Written by the Okta browser SDK and by the two stores that went with it. The first of
 * these holds an access token, an ID token **and** a refresh token, and `AuthenticationInfo`
 * held its own copy of the access and ID tokens.
 */
const LEGACY_KEYS = [
  "okta-token-storage",
  "okta-cache-storage",
  "okta-shared-transaction-storage",
  "okta-original-uri-storage",
  "AuthenticationInfo",
  "REDIRECT_URL",
];

/**
 * Clears what the browser-side sign-in flow left behind.
 *
 * Nothing writes these any more, but nothing deletes them either: a user who signed in
 * before this release keeps their old tokens in `localStorage` indefinitely, valid until
 * the refresh token's own lifetime runs out. Removing the code that wrote them does not
 * remove them, so this runs once at start-up.
 */
export function purgeLegacyTokenStorage(): void {
  LEGACY_KEYS.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
}
